'use strict';

//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

/**
 * colorisation : { name: string, color: string, stripes: 'full' | 'vertical' | 'horizontal' | 'diagonal', elements: { obj: string, storey: string }[]}
 */

export class cn_export_dynamic_colorisation_extension {

    constructor() {
        this.colorisations = [];
        this.title = 'Calques métiers'
    }

}


